import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

import { CustomerInfoService } from './customer-info.service';

import { CustomerInfoData } from './customer-info.data';

enum SUBMITTED_STATES {
  success = 'success',
  serverError = 'serverError',
  serverFailure = 'serverFailure',
}
const INPUT_FORM_CHAR_LIMIT = 200;
const TEXT_AREA_FORM_CHAR_LIMIT = 400;

@Component({
  selector: 'app-customer-info-dialog',
  templateUrl: './customer-info-dialog.component.html',
})
export class CustomerInfoDialogComponent implements OnInit {
  INPUT_FORM_CHAR_LIMIT = INPUT_FORM_CHAR_LIMIT;
  TEXT_AREA_FORM_CHAR_LIMIT = TEXT_AREA_FORM_CHAR_LIMIT;
  SUBMITTED_STATES = SUBMITTED_STATES;
  form = this.fb.group({
    email: ['', Validators.compose([Validators.required, Validators.email])],
    full_name: ['', Validators.required],
    phone_number: [''],
    organization_name: ['', Validators.required],
    message: ['', Validators.required],
  });

  hasSubmitted = false;
  isLoading = false;
  submittedState: SUBMITTED_STATES;

  constructor(
    private fb: FormBuilder,
    private customerInfoService: CustomerInfoService,
    @Inject(MAT_DIALOG_DATA) private data: CustomerInfoData,
  ) {}

  ngOnInit() {
    Object.keys(this.data || {}).forEach((dataKey: string) => {
      const targetForm = this.form.get(dataKey);
      targetForm.setValue(this.data[dataKey]);
      targetForm.disable();
    });
  }

  submitForm(form: FormGroup) {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.customerInfoService
      .sendInformation(form.getRawValue())
      .pipe(
        tap(() => {
          this.submittedState = this.SUBMITTED_STATES.success;
        }),
        catchError((error) => {
          if (500 <= error.status) {
            this.submittedState = this.SUBMITTED_STATES.serverFailure;
          }

          if (500 > error.status) {
            this.submittedState = this.SUBMITTED_STATES.serverError;
          }
          return of(error);
        }),
        finalize(() => {
          this.hasSubmitted = true;
          this.isLoading = false;
        }),
      )
      .subscribe();
  }

  resetState() {
    this.hasSubmitted = false;
  }
}
